import { JSX } from 'react';
import {
  EntityDisplayConfig,
  EntityDisplayConfigField
} from '../../../shared/interfaces/entity-display-config';
import { EntityDisplayConfigReview } from '../../../shared/components/EntityDisplayConfig/EntityDisplayConfigReview/EntityDisplayConfigReview';
import type { PipelineReviewContentProps } from '../components/PipelineReviewContent';

export interface PipelineReviewTocComponentProps {
  displayConfig: EntityDisplayConfig;
  className?: string;
  showDiffMode?: boolean;
  canUseDiffModeStyles?: (field: EntityDisplayConfigField) => boolean;
}

interface PipelineReviewSection {
  id: string;
  dataAccessKey: keyof PipelineReviewContentProps['content'];
  title: string | null;
  listItemTitle: string;
  componentProps?: Partial<PipelineReviewTocComponentProps>;
  Component: (props: PipelineReviewTocComponentProps) => JSX.Element;
}

export const PIPELINE_REVIEW_SECTIONS: PipelineReviewSection[] = [
  {
    id: 'source-configuration',
    dataAccessKey: 'sourceDisplayConfig',
    title: 'Source Configuration',
    listItemTitle: 'Source Configuration',
    componentProps: {
      className: 'w-50',
      showDiffMode: true
    },
    Component: EntityDisplayConfigReview
  },
  {
    id: 'destination-configuration',
    dataAccessKey: 'destinationDisplayConfig',
    title: 'Destination Configuration',
    listItemTitle: 'Destination Configuration',
    componentProps: {
      className: 'w-50',
      showDiffMode: true
    },
    Component: EntityDisplayConfigReview
  },
  {
    id: 'pipeline-configuration',
    dataAccessKey: 'integrationDisplayConfig',
    title: 'Pipeline Configuration',
    listItemTitle: 'Pipeline Configuration',
    componentProps: {
      className: 'w-50',
      showDiffMode: true
    },
    Component: EntityDisplayConfigReview
  },
  {
    id: 'object-configuration',
    dataAccessKey: 'objectsDisplayConfig',
    title: 'Object Configuration',
    listItemTitle: 'Object Configuration',
    componentProps: {
      className: 'w-20',
      showDiffMode: false,
      canUseDiffModeStyles: field => Number(field.value) > 0
    },
    Component: EntityDisplayConfigReview
  }
];
